const FRONT_CLIENT_ID =
  process.env.REACT_APP_FRONT_CLIENT_ID || "dd57479c4ccf0b1d9e69";

/**
 * OAuth redirect URI must match exactly what is registered in the Front Developer
 * portal (e.g. http://localhost:3000/dashboard/contacts for local dev).
 *
 * Always uses the browser origin when available so local (localhost:3000) and
 * production (https://app.twilanswer.com) each send the correct redirect_uri.
 */
export function getFrontOAuthRedirectUri() {
  let base;

  if (typeof window !== "undefined" && window.location?.origin) {
    base = window.location.origin;
  } else {
    base = (process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000/").replace(
      /\/$/,
      ""
    );
  }

  // Production is HTTPS; only normalize when not on localhost
  if (
    !/^https?:\/\/localhost(:\d+)?$/i.test(base) &&
    /^http:\/\/app\.twilanswer\.com$/i.test(base)
  ) {
    base = "https://app.twilanswer.com";
  }

  return `${base.replace(/\/$/, "")}/dashboard/contacts`;
}

export function buildFrontContactSyncAuthorizeUrl(organizationId) {
  const redirectUri = encodeURIComponent(getFrontOAuthRedirectUri());
  const state = encodeURIComponent(`front:contact_sync:${organizationId}`);
  return `https://app.frontapp.com/oauth/authorize?response_type=code&client_id=${FRONT_CLIENT_ID}&redirect_uri=${redirectUri}&state=${state}`;
}

/** @returns {{ provider: 'front_contact_sync' | 'slack', organizationId?: string, channelId?: string } | null} */
export function parseOAuthCallbackState(state) {
  if (!state) return null;
  if (state.startsWith("front:contact_sync:")) {
    return {
      provider: "front_contact_sync",
      organizationId: state.slice("front:contact_sync:".length),
    };
  }
  if (state.startsWith("channel_id:")) {
    return {
      provider: "slack",
      channelId: state.slice("channel_id:".length),
    };
  }
  return null;
}

/** Read org-level Front contact sync config from DynamoDB-shaped localStorage org. */
export function parseFrontContactSyncFromOrg(org) {
  const m = org?.front_contact_sync?.M;
  if (!m) {
    return {
      status: "disconnected",
      last_synced_at: "",
      last_error: "",
      front_workspace_url: "",
      front_teammate_email: "",
    };
  }
  return {
    status: m.status?.S || "disconnected",
    last_synced_at: m.last_synced_at?.S || "",
    last_error: m.last_error?.S || "",
    front_workspace_url: m.front_workspace_url?.S || "",
    front_teammate_email: m.front_teammate_email?.S || "",
  };
}

export function isFrontSyncInProgress(status) {
  return status === "initial_sync" || status === "syncing";
}

export function isFrontSyncConnected(status) {
  return (
    status === "connected" ||
    status === "error" ||
    status === "initial_sync" ||
    status === "syncing"
  );
}

export function getFrontSyncStatusLabel(status) {
  switch (status) {
    case "initial_sync":
      return "Importing contacts…";
    case "syncing":
      return "Syncing…";
    case "connected":
      return "Connected";
    case "error":
      return "Error";
    default:
      return "Disconnected";
  }
}
